import { v4 as uuidv4 } from "uuid";
import { getSizingOptions } from "@/react/components/shared/BuilderUI/utils/sizeStyleHelpers";
import {
  getFontSizeOptions,
  getFontWeightOptions,
} from "@/react/components/shared/BuilderUI/utils/textStyleHelpers";
import type { BaseBlock } from "@circle-react-shared/BuilderUI/DataModel.types";
import { defaultData as UserCardDefaultData } from "@circle-react-shared/BuilderUI/DefaultBlocks/Sections/UserCardBlock/UserCardDefaultData";
import { createImageBlock } from "@circle-react-shared/BuilderUI/DefaultBlocks/utils/mediaBlockHelpers";
import {
  createH5Block,
  createPBlock,
} from "@circle-react-shared/BuilderUI/DefaultBlocks/utils/textBlocksHelpers";
import { getBorderRadiusOptions } from "../../../utils/imgStyleHelpers";

export const createUserCardBlock = ({
  image = { signedId: "", placeholder: "" },
  header = "",
  description = "",
  size = "normal",
}: {
  image?: { signedId: string; placeholder?: string };
  header?: string;
  description?: string;
  size?: "normal" | "small";
}): BaseBlock => ({
  ...UserCardDefaultData,
  id: uuidv4(),
  props: {
    ...UserCardDefaultData.props,
    image: {
      ...UserCardDefaultData.props.image,
      prop: "children",
      type: "children",
      value: [
        createImageBlock({
          signedId: image.signedId,
          placeholder: image.placeholder,
          styles: {
            sizing: getSizingOptions({
              defaultValue: {
                width: "100%",
                height: "auto",
                minWidth: size === "normal" ? "48px" : "40px",
                minHeight: size === "normal" ? "48px" : "40px",
                maxWidth: size === "normal" ? "48px" : "40px",
                maxHeight: size === "normal" ? "48px" : "40px",
              },
            }),
            borderRadius: getBorderRadiusOptions({
              defaultValue: {
                border_left_top_radius: 20,
                border_left_bottom_radius: 20,
                border_right_top_radius: 20,
                border_right_bottom_radius: 20,
              },
            }),
          },
        }),
      ],
    },
    header: {
      ...UserCardDefaultData.props.header,
      prop: "children",
      type: "children",
      value: [
        createH5Block({
          text: header,
          styles: {
            fontSize: getFontSizeOptions(
              size === "normal" ? "1.125rem" : "0.875rem",
            ),
            fontWeight: getFontWeightOptions("500"),
          },
        }),
      ],
    },
    description: {
      ...UserCardDefaultData.props.description,
      prop: "children",
      type: "children",
      value: [
        createPBlock({
          text: description,
          paragraphStyle: "p3",
          styles: {
            fontSize: getFontSizeOptions(
              size === "normal" ? "1rem" : "0.875rem",
            ),
          },
        }),
      ],
    },
  },
});
